import { useParams } from 'react-router';
import { isDefined, isEmpty, isNullish } from 'remeda';
import { useLoadTemplateV2 } from 'shared/hooks/use-load-template-v2';
import { usePreviewTemplate } from '../api';
import { CHANNEL_CONFIGS } from './channels';
import { useActiveChannelAtom, useTemplateLanguageAtom } from './state';

export type PreviewTemplateBody = {
  preview: () => void;
  canPreview: boolean;
  isPreviewLoading: boolean;
};

export const usePreviewTemplateBody = (): PreviewTemplateBody => {
  const { templateId } = useParams<{ templateId: string }>();
  const { template } = useLoadTemplateV2(templateId);
  const [activeChannel] = useActiveChannelAtom();
  const [language] = useTemplateLanguageAtom();
  const { previewTemplate, isPreviewTemplateLoading } = usePreviewTemplate();

  const channel = isNullish(template)
    ? undefined
    : (activeChannel ?? CHANNEL_CONFIGS.find(({ key }) => !isEmpty(template.bodies[key]))?.key);
  const activeBody =
    isNullish(template) || isNullish(channel)
      ? undefined
      : template.bodies[channel].find(({ locale }) => locale === language);
  const canPreview = isDefined(activeBody) && !isEmpty(activeBody.body ?? '');

  const preview = () => {
    if (
      isNullish(template) ||
      isNullish(channel) ||
      isNullish(activeBody) ||
      isNullish(activeBody.body)
    )
      return;

    previewTemplate({
      id: template.id,
      download: channel === 'letter',
      data: {
        body: activeBody.body,
        subject: activeBody.subject,
        locale: activeBody.locale,
        groupedType: activeBody.groupedType,
        templateType: channel === 'letter' ? 'post' : 'email',
        stepType: template.stepType,
        includePdf: template.includePDF,
        includeUbl: template.includeUbl,
        fromName: activeBody.fromName,
        fromEmail: activeBody.fromEmail,
        replyToName: activeBody.replyToName,
        replyToEmail: activeBody.replyToEmail,
      },
    });
  };

  return { preview, canPreview, isPreviewLoading: isPreviewTemplateLoading };
};
